import { render } from "./GridTrepteDeVechime.vue?vue&type=template&id=c1e38158&ts=true"
import script from "./GridTrepteDeVechime.vue?vue&type=script&lang=ts"
export * from "./GridTrepteDeVechime.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__